import { useEffect, DependencyList } from "react";

/**
 * A custom hook to handle async operations in useEffect.
 * Passes `isActive` to verify the component is still mounted and the current run is not stale.
 */
export function useAsyncEffect(
  effect: (isActive: () => boolean) => Promise<void> | void,
  deps: DependencyList,
) {
  useEffect(() => {
    let active = true;
    const isActive = () => active;

    void Promise.resolve(effect(isActive)).catch((err) => {
      // Avoid unhandled promise rejections from async effects.
      if (isActive()) {
        // eslint-disable-next-line no-console
        console.error("useAsyncEffect: effect rejected", err);
      }
    });

    return () => {
      active = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
}
